/* eslint-disable import/no-anonymous-default-export */
const Sifting = ()=>(
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1.5L5.8 7.10593V11.3148L8.2 12.5V7.10593L13 1.5H1Z" fill="#8C8BDC" stroke="#8C8BDC" strokeWidth="2" strokeLinejoin="round"/>
    </svg>
)

export default {Sifting}